module.exports = __webpack_public_path__ + "static/media/DIngreso.d1fd8b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/DIngreso.jpg
// module id = 17
// module chunks = 0